import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

export default function ProtecaoCadastro({ children, tipoRequerido }) {
  const { user, isLoading } = useAuth();
  
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin" />
      </div>
    );
  }
  
  if (!user) return <Navigate to="/login" replace />;
  
  // ✅ CORREÇÃO: Usar user.tipo em vez de profile.tipo
  if (user?.tipo !== tipoRequerido) return <Navigate to="/" replace />;
  
  return children;
}